import { validatePassword } from "@utils/validatePassword"
import { useEffect, useState } from "react"
import styles from './PasswordValidation.module.scss'
import { NotValidIcon, ValidIcon } from "../SvgIcons"


const defaultPasswordValidations = [
  { id: 1, label: "Minimum 8 digits", isValid: false },
  { id: 2, label: "One number", isValid: false },
  { id: 3, label: "One uppercase character", isValid: false },
  { id: 4, label: "One lowercase character", isValid: false },
  { id: 5, label: "One special character", isValid: false },
]

/**
 * Props for PasswordValidation component
 * @property password - current password value to validate
 * @property clearValidation - optional flag to reset validations
 * @property setIsPasswordValid - state setter to reflect overall validity
 * @property isVisible - controls visibility with smooth transition when toggled
 */
interface Props {
  password: string
  clearValidation?: boolean
  setIsPasswordValid: React.Dispatch<React.SetStateAction<boolean>>
  isVisible?: boolean
}

const PasswordValidation = ({
  password,
  setIsPasswordValid,
  clearValidation,
  isVisible = true,
}: Props) => {
  const [validations, setValidations] = useState(defaultPasswordValidations)

  useEffect(() => {
    const checkValidations = defaultPasswordValidations.map(el => {
      const isValid = validatePassword(el?.id, password)
      return { ...el, isValid }
    })
    setValidations(checkValidations)
  }, [password])

  useEffect(() => {
    if (validations?.every(el => el.isValid)) {
      setIsPasswordValid(true)
    } else {
      setIsPasswordValid(false)
    }
  }, [validations, setIsPasswordValid])

  useEffect(() => {
    setValidations(defaultPasswordValidations)
  }, [clearValidation])

  return (
    <div
      className={`${styles["password-validation"]} ${isVisible ? styles["visible"] : styles["hidden"]}`}
    >
      {validations?.map(el => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }} key={el.id}>
            {el.isValid ? <ValidIcon /> : <NotValidIcon />}{" "}
            <p
              className={`fs12 fw500  ${el.isValid ? styles["valid"] : styles["not-valid"]}`}
            >
            {el.label}
            </p>
          </div>
        )
      })}
    </div>
  )
}

export default PasswordValidation
